import type { Edge } from '@atlaskit/pragmatic-drag-and-drop-hitbox/closest-edge';

export const getEdgeForRerank = (
	sourceIndex: number,
	destinationIndex: number,
	sortDirection: string | undefined,
): Edge => {
	// When sorting DESC, the visual direction is inverted
	// Moving up visually (lower index) means moving down in ascending order
	if (sortDirection === 'DESC') {
		return sourceIndex > destinationIndex ? 'bottom' : 'top';
	}
	// ASC: normal logic
	return sourceIndex > destinationIndex ? 'top' : 'bottom';
};
